var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSort48Filled = function SvgIconSort48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 26.84h-9.6c-1.16 0-2.21.69-2.66 1.75-.46 1.07-.24 2.3.56 3.14l4.8 5.06c.54.58 1.31.91 2.1.91s1.56-.33 2.1-.9l4.8-5.06c.8-.84 1.02-2.07.56-3.14a2.883 2.883 0 0 0-2.66-1.75v-.01ZM19.2 21.16h9.6c1.16 0 2.21-.69 2.66-1.75.45-1.06.24-2.3-.56-3.14l-4.8-5.06a2.89 2.89 0 0 0-2.1-.9c-.79 0-1.56.33-2.1.9l-4.8 5.06c-.8.84-1.02 2.08-.56 3.14.46 1.07 1.5 1.75 2.66 1.75Z",
    fill: "current"
  })));
};
export default SvgIconSort48Filled;